import orgHttps from '../init/orgHttps';

//ORG-CAMP-01 : Populate the information on camp dashboard
export async function orgCampdashFun() {
    const result = await orgHttps.get(`/org/camp`);
    return result;
}

//ORG-CAMP-02 : To get complete content of camp
export async function orgCampFun(campId) {
    const result = await orgHttps.get(`/org/camp/${campId}`);
    return result;
}

//ORG-CAMP-03 : Gives the list of booked customers for given camp tour
export async function orgCampBookedFun(campId) {
    const result = await orgHttps.get(`/org/camp/${campId}/booked`);
    return result;
}

//ORG-CAMP-04 : Complete details of an organizer
export async function campOrgInfoFun() {
    const result = await orgHttps.get(`/org/camp/orgInfo`);
    return result;
}

//ORG-CAMP-05 : Create new camp organizer
export async function orgCampRegisterFun(data) {
    const result = await orgHttps.post(`org/camp/register`, data);
    return result;
}

//ORG-CAMP-06 : To create new room category
export async function campRoomCreateFun(data) {
    const result = await orgHttps.post(`org/camp/room-create`, data);
    return result;
}

//ORG-CAMP-07 : To add new booking manually
export async function campMnFun(campId, data) {
    const result = await orgHttps.post(`org/camp/manual/${campId}`, data);
    return result;
}

//ORG-CAMP-08 : To add more rooms in the camp room category
//for particular type(2 sharing, single, 3 sharing)
export async function campRoomNumAddFun(roomCatId, data) {
    const result = await orgHttps.patch(`org/camp/room-add/${roomCatId}`, data);
    return result;
}

//ORG-CAMP-09 : To delete rooms in the camp room category
export async function campRoomNumDeleteFun(roomCatId, roomId, data) {
    const result = await orgHttps.patch(`org/camp/room-delete/${roomCatId}/${roomId}`, data);
    return result;
}

//ORG-CAMP-10 : To delete a particular room category of the particualr camping
//dont let the camping to be deleted even if it has single booking //it has to be cancalled
export async function campRoomCatDeleteFun(campRoomCatId) {
    const result = await orgHttps.delete(`org/camp/${campRoomCatId}`);
    return result;
}

//ORG-CAMP-14 : get OTP to register Camp organizer
export async function orgCampRegOTP(data, method) {
    const result = await orgHttps.post(`org/camp/register/otp?method=${method}`, data);
    return result;
}

/*
 * Stays (new Listing / StayBooked) — backend controllers/campOrganizer/stay/stayOrg.js
 */
//ORG-CAMP-20 : check-ins + stats   params { date: next|today|previous, limit, offset }
export const orgStayDashboardFun = (params) => orgHttps.get('org/camp/stay/dashboard', { params });

//ORG-CAMP-21 : the organizer's stays with their room types
export const orgStayListingsFun = () => orgHttps.get('org/camp/stay/listings');

//ORG-CAMP-22 : bookings   params { date: upcoming|completed|all, listingId, limit, offset }
export const orgStayBookingsFun = (params) => orgHttps.get('org/camp/stay/bookings', { params });

//ORG-CAMP-23 : add a phone / walk-in booking
export const orgStayManualFun = (data) => orgHttps.post('org/camp/stay/manual', data);

//ORG-CAMP-24 : cancel a booking (website / app bookings are refunded in full)
export const orgStayCancelFun = (bookingId) => orgHttps.post('org/camp/stay/cancel', { bookingId });

//ORG-CAMP-25 : billing rows   params { status: not-eligible|generated|completed, limit, offset }
export const orgStayBillingFun = (params) => orgHttps.get('org/camp/stay/billing', { params });

//ORG-CAMP-26 : payouts   params { limit, offset }
export const orgStayPayoutsFun = (params) => orgHttps.get('org/camp/stay/payouts', { params });

//ORG-CAMP-27 : one payout with its bookings
export const orgStayPayoutFun = (id) => orgHttps.get(`org/camp/stay/payouts/${id}`);

//ORG-CAMP-28 : reviews of the organizer's stays   params { listingId, limit, offset }
export const orgStayReviewsFun = (params) => orgHttps.get('org/camp/stay/reviews', { params });
